<template>
  <div>
    <div class="flex justify-between items-center p-5">
      <div class="flex items-center">
        <d-icon :icon="open ? 'folder-open' : 'folder'" class="text-4xl" />
        <div class="mx-5">
          <p class="font-bold">
            {{ file.name }}
          </p>
          <p v-if="!canEdit" class="text-sm">
            {{ formatDate(file.createdAt) }}
          </p>
          <p v-else class="text-sm">
            <a href="javascript:;" class="underline" @click.stop="launchEditModal">Edit Details</a>
          </p>
        </div>
      </div>
      <d-tooltip v-if="hasChildFiles" label="Either move or delete the subitems in this folder first">
        <d-icon icon="trash" class="text-error opacity-75 cursor-not-allowed" />
      </d-tooltip>
      <d-icon v-else icon="trash" class="text-error cursor-pointer" @click.stop="removeItem(file)" />
    </div>

    <!-- Folder Edit Modal -->
    <d-modal
      :active="showFolderModal"
      :width="850"
      @close="closeFolderModal"
      :can-cancel="['escape', 'x', 'outside']"
    >
      <FolderModal
        :file="file"
        :content-listing="contentListing"
        @close="closeFolderModal"
        @saved="handleModalSaved"
      />
    </d-modal>
  </div>
</template>

<script>
  import { deleteItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import FolderModal from '../Organization/FolderModal.vue';

  export default {
    components: {
      FolderModal,
    },

    inject: ['getFiles', 'contentListing', 'saveDraggable'],
    props: {
      file: {
        type: Object,
        default: () => ({}),
      },
      hasChildFiles: Boolean,
      open: Boolean,
      canEdit: Boolean,
    },

    data() {
      return {
        showFolderModal: false,
      };
    },

    methods: {
      async removeItem(item) {
        await deleteItem(item.id, this.contentListing.type);
        await this.getFiles();
      },

      launchEditModal() {
        this.showFolderModal = true;
      },

      closeFolderModal() {
        this.showFolderModal = false;
      },

      async handleModalSaved() {
        // Refresh the files after a successful save
        await this.getFiles();
        // Also call saveDraggable if needed
        if (this.saveDraggable) {
          await this.saveDraggable();
        }
      },

      formatDate(date) {
        if (!date) return '';
        return new Date(date).toLocaleDateString();
      },
    },
  };
</script>